// Loads every asset's weekly series and computes its trend context. One signal
// holds the results; the App renders from it. Each asset resolves independently
// so one dead symbol can't blank the whole board.

import { signal } from "@preact/signals";
import { ASSETS, fetchWeeklyCloses } from "../api/data";
import { computeContext, type AssetResult } from "../engine/context";

export const results = signal<AssetResult[]>([]);
export const loading = signal(true);
export const loadedAt = signal<number | null>(null);

export async function loadAll(): Promise<void> {
  loading.value = true;
  const settled = await Promise.all(
    ASSETS.map(async (def): Promise<AssetResult> => {
      try {
        const series = await fetchWeeklyCloses(def.symbol);
        return computeContext(def, series);
      } catch (e) {
        return { def, error: e instanceof Error ? e.message : String(e) };
      }
    }),
  );
  results.value = settled;
  loadedAt.value = Date.now();
  loading.value = false;
}
